import {Component, OnInit, ViewChild} from '@angular/core';
import * as turf from '@turf/turf';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {GoogleMap} from '@angular/google-maps';
import {DrawingService} from '../../services/drawing.service';
import {Routenames} from '../../routenames';
import {ImportEntity} from '../../classes/import.entity';
import {Converter} from '../../../../../api/conversion/converter/src/converter.class';
import {Title} from '@angular/platform-browser';
import {TtmService} from '../../services/ttm.service';
import {combineLatest, Subscription} from 'rxjs';
import rdToWgs84 from 'rd-to-wgs84';

@Component({
    selector: 'app-data-converter',
    templateUrl: './data-converter.component.html',
    styleUrl: './data-converter.component.scss'
})
export class DataConverterComponent extends Converter implements OnInit {

    @ViewChild('googleMap') googleMap: GoogleMap | undefined;

    center = null;
    zoom = null;
    file = '';


    options: google.maps.MapOptions = {
        mapId: '55a928ad53a65407',
        center: {lat: 53.245, lng: 6.55},
        zoom: 15,
        tilt: 0,
        isFractionalZoomEnabled: false
    };

    showMap: {
        text: string,
        connections: ImportEntity[][],
        firstLines: ImportEntity[],
        bord: ImportEntity,
        parent?: ImportEntity[],
        parentInsert: ImportEntity,
        otherPoints?: ImportEntity[],
        location?: ImportEntity
    };

    viewNearLines: ImportEntity[];
    outlinePoly: any;
    outlinePoints: any;
    textPolygons: any;

    subscriptions = new Subscription();

    constructor(private router: Router,
                private drawingService: DrawingService,
                private ttmService: TtmService,
                private activeRoute: ActivatedRoute,
                private confirmDialog: ConfirmDialogService,
                private title: Title) {
        super();
    }

    ngOnInit() {
        this.title.setTitle('Data converter - TSNed App');
        if (this.activeRoute.snapshot.params['id']) {
            this.subscriptions.add(combineLatest([
                this.drawingService.get(+this.activeRoute.snapshot.params['id']),
                this.ttmService.types()
            ]).subscribe(([drawingResult, typesResult]) => {
                this.drawing = drawingResult.data;
                this.doConvert(this.drawing.json_data, typesResult.data);
            }));
        }
    }

    showOnMap(bord: {
        text: string,
        connections?: ImportEntity[][],
        firstLines?: ImportEntity[],
        bord?: ImportEntity
    }) {
        this.showMap = bord as any;
        this.showMap.parent = this.flattened.filter(f => f.handle === 84386357);
        this.showMap.parentInsert = bord.bord.entities.find(e => e.name === 'bm21');
        this.outlinePoly = this.flattened.find(f => f.name === '_Botserb')?.polygon;


        const searchForFirstConnectionsList = this.flattened.filter(entity => {
            return ['LWPOLYLINE', 'LINE'].includes(entity.type);
        });
        this.viewNearLines = searchForFirstConnectionsList.filter(entity => {
            const coord = {
                lat: (entity.lat ?? entity.wgsStart?.lat),
                lng: (entity.lng ?? entity.wgsStart?.lng)
            };
            const coordEnd = entity?.points?.length ? {
                lat: (entity?.wgsPoints[entity?.points?.length - 1]?.lat ?? entity.wgsEnd?.lat),
                lng: (entity?.wgsPoints[entity?.points?.length - 1]?.lng ?? entity.wgsEnd?.lng)
            } : null;
            if (coord.lng && entity.layer !== 'viewport') {
                return this.distanceM(bord.bord, coord) < 2000 || (coordEnd && this.distanceM(bord.bord, coordEnd) < 2000);
            }
            return false;
        });
        this.textPolygons = this.flattened.filter(entity => entity.type === 'TEXT' && !!entity.polygon).map(entity => entity.polygon);

        if (bord.bord.rotation) {
            this.showMap.bord['rotLine'] = this.createDirectionLine(bord.bord.lng, bord.bord.lat, bord.bord.rotation);
        }
        console.log(this.showMap);
        console.log(this.showMap.bord['pos']);
        setTimeout(() => {
            this.center = {lat: bord.bord.lat, lng: bord.bord.lng};
            this.zoom = 18;
        });
    }

    showOnMapConn(bord: {
        text: string,
        connections?: ImportEntity[][],
        firstLines?: ImportEntity[],
        bord?: ImportEntity,
        otherPoints?: ImportEntity[]
    }, handle: any) {
        console.log(bord);
        bord.firstLines = bord.firstLines.filter(f => f.layer !== 'wy-kleur-255');
        this.showMap = bord as any;
        //this.showMap.parent = this.flattened.filter(f => f.parent_handle == handle);
        this.showMap.parent = this.flattened.filter(f => f.parent_handle == 84372605 || [84372605, 84291888, 84291889].includes(f.handle));
        this.showMap.parentInsert = this.flattened.find(f => f.handle == handle);
        this.showMap.otherPoints = bord.otherPoints;
        setTimeout(() => {
            this.center = {lat: bord.bord.lat, lng: bord.bord.lng};
            this.zoom = 19;
        });
        this.showMap = bord as any;
    }

    writeToEntitiesDb() {
        const {ttms, otherItems, xRefs} = this.getTtmsAndOthers();
        this.drawingService.saveTtms(this.drawing.id, ttms).subscribe(result => {
            this.drawingService.saveEntities(this.drawing.id, otherItems).subscribe(() => {
                this.drawingService.saveDrawingMaps(this.drawing.id, xRefs).subscribe(() => {
                    this.confirmDialog.confirm('Opgeslagen', 'Entities zijn opgeslagen', 'Open project', 'Sluit modal').then(() => {
                        this.router.navigate([Routenames.Projects, this.drawing.project_id], {queryParams: {drawing: this.drawing.id}});
                    }, () => {
                    });
                });
            });
        });
    }

    polyClick(connection) {
        console.log(connection);

        /*const line = turf.lineString([
            [connection.wgsStart.lng, connection.wgsStart.lat],
            [connection.wgsEnd.lng, connection.wgsEnd.lat]
        ]);
        const lineLength = turf.length(line, {units: 'centimeters'});
        console.log(lineLength);*/
    }

    showPoly(bord: ImportEntity) {
        console.log(bord['outlinePoly']);
        this.outlinePoly = bord['outlinePoly'];
    }

}
